import { SyncStatusView } from '../../apps/professional-app/fa/MeetingSummary/ExternalUpdates/models'

const _GROUP_TASKS_WITHIN_SECONDS = 30

const partitionByType = (syncStatuses: SyncStatusView[]): [SyncStatusView[], SyncStatusView[]] => {
  return syncStatuses.reduce<[SyncStatusView[], SyncStatusView[]]>(
    ([tasks, nonTasks], syncStatus) => (syncStatus.type === 'task' ? [[...tasks, syncStatus], nonTasks] : [tasks, [...nonTasks, syncStatus]]),
    [[], []],
  )
}

const getTimeDifferenceInSeconds = (dateA: string, dateB: string): number => {
  return Math.abs(new Date(dateA).getTime() - new Date(dateB).getTime()) / 1000
}

const areWithinTimeWindow = (statusA: SyncStatusView, statusB: SyncStatusView, windowSeconds: number): boolean => {
  return getTimeDifferenceInSeconds(statusA.syncedAt, statusB.syncedAt) <= windowSeconds
}

const consolidateTaskGroup = (groups: SyncStatusView[][], current: SyncStatusView): SyncStatusView[][] => {
  if (groups.length === 0) {
    return [[current]]
  }

  const lastGroup = groups[groups.length - 1]
  const lastTask = lastGroup[lastGroup.length - 1]

  if (areWithinTimeWindow(lastTask, current, _GROUP_TASKS_WITHIN_SECONDS)) {
    return [...groups.slice(0, -1), [...lastGroup, current]]
  }

  return [...groups, [current]]
}

const groupTasksByTimeWindow = (tasks: SyncStatusView[]): SyncStatusView[][] => {
  const sortedTasks = [...tasks].sort((a, b) => new Date(a.syncedAt).getTime() - new Date(b.syncedAt).getTime())

  return sortedTasks.reduce(consolidateTaskGroup, [])
}

const createConsolidatedTask = (group: SyncStatusView[]): SyncStatusView => {
  const [first, ...rest] = group

  return rest.length > 0 ? { ...first, groups: rest } : first
}

const consolidateGroups = (groups: SyncStatusView[][]): SyncStatusView[] => {
  return groups.map(createConsolidatedTask)
}

const sortByTimestampDescending = (statuses: SyncStatusView[]): SyncStatusView[] => {
  return [...statuses].sort((a, b) => new Date(b.syncedAt).getTime() - new Date(a.syncedAt).getTime())
}

export const useConsolidateTasksSyncedTogether = (syncStatuses: SyncStatusView[]): SyncStatusView[] => {
  const [tasks, nonTasks] = partitionByType(syncStatuses)
  const taskGroups = groupTasksByTimeWindow(tasks)
  const consolidatedTasks = consolidateGroups(taskGroups)

  return sortByTimestampDescending([...consolidatedTasks, ...nonTasks])
}
